export default __webpack_public_path__ + "static/Entenda0030-322b06a7f277614ee0a1542007989b97.jpg";